import AutoSearch from 'components/AutoSearch';
import React, { useState } from 'react';
import useTranslation from 'common/customHooks/translations';

function Symptoms({ state, setState }) {
  const t = useTranslation();

  const [input, setInput] = useState(state.selectDisease);

  function selectvalue(val, id) {
    console.log(id);
    // setState({ ...state, selectDisease: val });
    setState((prevState) => ({ ...prevState, selectDisease: val }));
    setState((prevState) => ({ ...prevState, symptons_id: id }));
  }

  return (
    <div className=''>
      <h3 className='center-styl my-6 text-base font-semibold text-color-yellow'>
        {t.symptoms}
      </h3>
      <div className='center-styl'>
        <div className='treatment-view '>
          {state.disease != '' ? (
            <AutoSearch
              input={input}
              defaultvalue={state.selectDisease}
              setInput={setInput}
              selectvalue={selectvalue}
              placeholder={t.addsymptoms}
              suggestions={state.disease}
            />
          ) : (
            'loading'
          )}
        </div>
      </div>
    </div>
  );
}

export default Symptoms;
